import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend) // Load translations from public/locales
  .use(initReactI18next)
  .init({
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // React already escapes
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json" // Path to translations in public
    }
  });

export default i18n;
